import styled from '@emotion/styled'

export const ActionsCell = styled.div`
  display: flex;
  justify-content: center;
`
